import React, { Fragment, Component } from "react";
import _ from 'lodash';
import CloseIcon from "@material-ui/icons/Close";
import {PrimaryButton, SecondaryButton} from 'components/Global/Buttons'
import styled from 'styled-components';
import { compose } from "redux";
import { connect } from "react-redux";
import { getAllInfoForClosingRefiDeal, closeRefiDeal, acknowledgeRedirect } from 'store/state/deal';
import {
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Step,
    StepLabel, 
    Stepper,
  } from "@material-ui/core";
import numberFormatter from 'utils/numberFormatter';
import PayoffComponent from "./PayoffComponent";
import TerminateHedgeComponent from "./TerminateHedgeComponent";
import  {seniorityMap} from  "constants/loanSeniorityTypes";
import hedgeStatuses from "constants/hedgeStatus";
import loanStatuses from "constants/loanStatuses"

  const TERMINATED_HEDGE = hedgeStatuses.TERMINATED;
  const ACTIVE_HEDGE = hedgeStatuses.ACTIVE;
  const LB_BLUE = "#2196f3";
  const WINNING_QUOTE = loanStatuses.WINNING_QUOTE;
  const seniority = seniorityMap;

  const GrayP = styled.p`
    color: #777777;
  `;

  const ConfirmPageContainerDiv = styled.div`
  width: 90%;
  min-height: 100px;
  `;

  const StyledDialogIconButton = styled(IconButton)`
    && {
      position: absolute;
      top: 8px;
      right: 13px;
    }`;
  
  const StyledDialog = styled(Dialog)`
  &&&{
    min-width: 700px;
  }
  `
  
  const StyledDialogContent = styled(DialogContent)`
    && {
      padding-left: 20px;
      padding-right: 20px;
      min-height: 300px;
      overflow: hidden;
    }
  `;

  const StepperContainer = styled.div`
    width: 100%;
    text-align: center;
    vertical-align: middle;
    `;
  const StepperContainerInner = styled.div`
  width: 75%;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
`;
  
  const ModalTitle = styled.p`
    font-weight: normal;
    font-size: 17pt;
    margin-left: 20px;
  `;

  export class CloseDealRefiModal extends Component {

    componentDidMount(){
      this.props.getAllInfoForClosingRefiDeal({dealId: this.props.dealId});
    }

    componentWillUnmount(){
        //todo clean out the store deal > closeRefiModelInfo
    }

    componentDidUpdate(prevProps) {
      if(this.props.redirectTo){
        this.props.acknowledgeRedirect();
        this.props.history.push(this.props.redirectTo);
      }
    }

    stepForward = (amount) => {
      if(!amount) amount = 1;
      this.setState({activeStep:this.state.activeStep+amount});
    }
  
    stepBackward = (amount) => {
      if(!amount) amount = 1;
      this.setState({activeStep:this.state.activeStep-amount});
    }

    submit = () => {
      this.props.handleClose();
      this.props.closeRefiDeal({
        dealId : this.props.deal.id,
        loanInfo: this.state.loanInfo,
        hedgeInfo: this.state.hedgeInfo,
      });
    }

    state = {
        activeStep: 0,
        loanInfo : {}, //key = loanId, mapped to object of {balance, prepaymentPenalty, paidOffDate}
        hedgeInfo : {}, //key = hedgeId, mapped to object of {shouldTerminate, notinoal, terminationValue, terminationDate}
        absentOfHedges : false,
    }

    render() {
        if(this.props.deal && this.props.deal.hedges.length === 0){
          if(!this.state.absentOfHedges){
            this.setState({absentOfHedges: true});
          }
        }else if(this.props.deal){
          let absentOfHedges = true;
          this.props.deal.hedges.forEach(hedge=>{
            if(hedge.hedgeStatusId === ACTIVE_HEDGE){
              absentOfHedges = false;
            }
          });
          if(this.state.absentOfHedges !== absentOfHedges){
            this.setState({absentOfHedges});
          }
        }
        const absentOfHedges = this.state.absentOfHedges;
        const {isOpen, dealId, handleClose, deal} = this.props;
        if(!deal){
            return null; //dealId should be passed in, deal itself should be retreived from the store on componentDidMount
        }
        return (
          <StyledDialog 
              modal = {true}
              maxWidth= {"md"}
              fullWidth={true}
              open={isOpen}  
              autoDetectWindowHeight={false} 
              autoScrollBodyContent={false}
              contentStyle={{width: "700px", maxWidth: "none"}}
              onClose = {handleClose}
          >
            <ModalTitle>Confirm Close</ModalTitle>
            <StyledDialogIconButton onClick={handleClose}><CloseIcon id="closeIcon" style={{ fontSize: 22 }} /></StyledDialogIconButton>
            <StepperContainer>
              <StepperContainerInner>
                <Stepper style={{width:"100%"}}activeStep={this.state.activeStep} alternativeLabel>
                  <Step key="first" >
                    <StepLabel >
                      Pay Off Loans
                    </StepLabel>
                  </Step>
                  {!absentOfHedges &&
                    <Step key="second" >
                      <StepLabel >
                        Terminate Hedges
                      </StepLabel>
                    </Step>
                  }
                  <Step key="third" >
                    <StepLabel >
                      Confirm
                    </StepLabel>
                  </Step>
                </Stepper>
              </StepperContainerInner>
            </StepperContainer>
            <StyledDialogContent>
                {this.renderCurrentPageComponent()}
            </StyledDialogContent>
            <DialogActions>
              <SecondaryButton onClick = {handleClose} >Cancel</SecondaryButton>
              {this.state.activeStep > 0 &&
                <SecondaryButton onClick = {()=>this.stepBackward()}>Back</SecondaryButton>
              }
              {this.state.activeStep < (absentOfHedges ? 1 : 2) && 
                <PrimaryButton onClick = {()=>this.stepForward()}>Next</PrimaryButton>
              }
              {this.state.activeStep === (absentOfHedges ? 1 : 2) &&
                <PrimaryButton onClick = {this.submit}>Close Deal</PrimaryButton>
              }
              
            </DialogActions>
        </StyledDialog>
        )
    }

    setLoanProperty = (loanId, propName, value) => {
      let newLoanInfo = this.state.loanInfo;
      if (newLoanInfo[loanId]){
        newLoanInfo[loanId][propName] = value;
      }
      else{
        let newObject = {};
        newObject[propName] = value; 
        newLoanInfo[loanId] = newObject;
      }
      this.setState({loanInfo : newLoanInfo})
    }

    setHedgeProperty = (hedgeId, propName, value) => {
      let newhedgeInfo = this.state.hedgeInfo;
      if (newhedgeInfo[hedgeId]){
        newhedgeInfo[hedgeId][propName] = value;
      }
      else{
        let newObject = {};
        newObject[propName] = value; 
        newhedgeInfo[hedgeId] = newObject;
      }
      this.setState({hedgeInfo : newhedgeInfo})
    }

    renderCurrentPageComponent = () => {
      let stepToRender = this.state.activeStep;
      if(this.state.absentOfHedges){
        if(stepToRender === 1) {
          stepToRender = 2;
        }
      }
      switch(stepToRender){
        case 0:
          return (
            <PayoffComponent 
                setLoanProperty = {this.setLoanProperty}
                loanInfo = {this.state.loanInfo}
            />
          );
        case 1:
          return (
              <TerminateHedgeComponent
                hedgeInfo = {this.state.hedgeInfo}
                setHedgeProperty = {this.setHedgeProperty}
              />
          );
        case 2: 
            let seniorWinner = null;
            let subordinateWinner = null;
            let supplementalWinner = null
            if(!this.props.deal) return null;
            this.props.deal.loans.forEach(loan => {
              if(loan.version === this.props.deal.version && loan.loanStatusId === WINNING_QUOTE){
                switch (seniority[loan.loanSeniorityId]){
                  case "Senior":
                    seniorWinner = loan;
                    break;
                  case "Supplemental":
                    supplementalWinner = loan;
                    break;
                  case "Subordinate":
                    subordinateWinner = loan;
                    break;
                }
              }
            });
            if(seniorWinner){
              seniorWinner.title = seniorWinner.loanProvider[0] ? `${seniorWinner.loanProvider[0].name}` : "No Lender Selected";
              if(seniorWinner.loanTermMonths) seniorWinner.title += ` | ${(parseFloat(seniorWinner.loanTermMonths)/12).toFixed(1)} Years`
              else seniorWinner.title += ` | N/A`;
              if(seniorWinner.rateTypeRef) seniorWinner.title += ` | ${_.startCase(_.toLower(seniorWinner.rateTypeRef.value))}`
              else seniorWinner.title += ` | N/A`;
              if(seniorWinner.amount) seniorWinner.title += ` | ${numberFormatter.maskCurrency(seniorWinner.amount)}`;
              else seniorWinner.title += ` | N/A`
            }
            if(subordinateWinner){
              subordinateWinner.title = subordinateWinner.loanProvider[0] ? `${subordinateWinner.loanProvider[0].name}` : "No Lender Selected";
              if(subordinateWinner.loanTermMonths) subordinateWinner.title += ` | ${(parseFloat(subordinateWinner.loanTermMonths)/12).toFixed(1)} Years` 
              else subordinateWinner.title += ` | N/A`;
              if(subordinateWinner.rateTypeRef) subordinateWinner.title += ` | ${_.startCase(_.toLower(subordinateWinner.rateTypeRef.value))}`
              else subordinateWinner.title += ` | N/A`;
              if(subordinateWinner.amount) subordinateWinner.title += ` | ${numberFormatter.maskCurrency(subordinateWinner.amount)}`;
              else subordinateWinner.title += ` | N/A`
            }
            if(supplementalWinner){
              supplementalWinner.title = `${supplementalWinner.loanProvider[0].name}`;
              if(supplementalWinner.loanTermMonths) supplementalWinner.title += ` | ${(parseFloat(supplementalWinner.loanTermMonths)/12).toFixed(1)} Years`
              else supplementalWinner.title += ` | N/A`
              if(supplementalWinner.rateTypeRef) supplementalWinner.title += ` | ${supplementalWinner.rateTypeRef.value}`
              else supplementalWinner.title += ` | N/A`
              if(supplementalWinner.amount) supplementalWinner.title += ` | ${numberFormatter.maskCurrency(supplementalWinner.amount)}`;
              else supplementalWinner.title += ` | N/A`
            }
            return (
              <ConfirmPageContainerDiv>
                <GrayP style={{marginBottom: "40px"}}>                  
                    You have selected the following quotes for this deal. 
                    This information can only be reverted by a <span style={{color:LB_BLUE}}><a href="mailto: support@loanboss.com">LoanBoss Administrator.</a></span>
                </GrayP>
                {seniorWinner && 
                  <GrayP style={{marginLeft: "50px"}}>                  
                      <b>Senior Quote:</b> {`${seniorWinner.title}`}
                  </GrayP>
                }
                {subordinateWinner && 
                  <GrayP style={{marginLeft: "50px"}}>                  
                      <b>Subordinate Quote:</b> {`${subordinateWinner.title}`}
                  </GrayP>
                }
                {supplementalWinner && 
                  <GrayP style={{marginLeft: "50px"}}>                  
                      <b>Supplemental Quote:</b> {`${supplementalWinner.title}`}
                  </GrayP>
                }
                <div style={{position: "absolute", bottom: 60}}>
                <GrayP >                  
                   Are you sure you want to do this?
                </GrayP>
                <GrayP>                  
                    <b>NOTE:</b> All guests that have been added to this deal will be removed upon clicking “Close Deal”.
                </GrayP>
                </div>
              </ConfirmPageContainerDiv>
            );
        default:
          return null;
      }
    }

  }//end of class

  
    function mapStateToProps({ deal }) {
        return {
            deal: deal.closeRefiModelInfo,
            redirectTo: deal.redirectTo,
        };
    }
  
  export default compose(
    connect(
      mapStateToProps,
      {
        getAllInfoForClosingRefiDeal,
        closeRefiDeal,
        acknowledgeRedirect,
      }
    )
  )(CloseDealRefiModal);